<template>
  <a
    class="block py-1.5 px-3 text-gray-600 hover:text-gray-800"
    :class="{'text-gray-600': show, 'text-gray-400': !show}"
    href=""
    v-if="showShareBtn && show"
    @click.stop.prevent="click"
    >{{$t('Share')}}</a>
</template>

<script>
import ShareButton from '../../../mixins/ShareButton'

export default {
  mixins: [ShareButton],
  emits: ['onselect'],
  props: ['item'],
  computed: {
    show() {
      return this.item.hidden === null
        && this.item.can_download
        && (this.item.type === 'folder' || this.item.published__bc_document_rev_id !== null)
    },
  },
  methods: {
    click() {
      this.bcSelectedStore.resetSelected()
      this.bcSelectedStore.select(this.item)
      this.clickShareBtn()
      this.$emit('onselect')
    }
  },
}
</script>

<style lang="scss" scoped></style>
